module.exports = __webpack_public_path__ + "static/media/group-cover-3.9c73420c.jpg";